"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOX_WORDINGS = void 0;
exports.BOX_WORDINGS = {
    LOCKED: {
        STATUS: 'Non disponible à la vente pour le moment',
    }
};
exports.default = exports.BOX_WORDINGS;
//# sourceMappingURL=Box.js.map